import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    productBeingConfigured: null,
    powerUp: null,
    selectedSKU: null,
    productSKU: null,
    accessorySKU: null,
    loaded: false,
    productOptions: null,
    storeId: null,
    locale: null,
    currency: "USD",
    speakerPrice: null,
    configuration: {
      ConfigId: null,
      CustomText: null,
      Fabric: null,
      Caps: null,
      Icon: null,
      Spine: null,
      Loop: null,
      Product: null
    },
    httpError: false,
    font: "News Gothic",
    luckyCount: null,
    editingFeelingLucky: false,
    inputText: null,
    sessionToken: null,
    defaultText: "YOUR TEXT HERE",
    socialImageURL: null,
    forbiddenText: [
      "UE SUCK",
      "ULTIMATE EARS SUCK",
      "BOOM SUCK",
      "BOOM 3 SUCK",
      "FUCK UE",
      "FUCK ULTIMATE EARS",
      "JBL",
      "SAMSUNG",
      "APPLE",
      "BOSE",
      "ION AUDIO",
      "SONY",
      "SONOS",
      "BANG & OLUFSEN",
      "BANG AND OLUFSEN",
      "B&O",
      "B&O PLAY",
      "SENNHEISER",
      "HARMAN KARDON",
      "BOWERS & WILKINS",
      "BOWERS AND WILKINS",
      "ALTEC LANSING"
    ],
    Defaults: {
      Fabric: {
        Front: {
          Filename:
            "https://res.cloudinary.com/publish-prod/image/upload/v1549414045/configurator/front-white.png",
          CD_PublicId: "configurator/front-white",
          CD_Version: "v1549414045",
          CD_Format: "png",
          CD_BasePath: "https://res.cloudinary.com/publish-prod/image/upload/"
        },
        Back: {
          Filename:
            "https://res.cloudinary.com/publish-prod/image/upload/v1549414042/configurator/back-white.png",
          CD_PublicId: "configurator/back-white",
          CD_Version: "v1549414042",
          CD_Format: "png",
          CD_BasePath: "https://res.cloudinary.com/publish-prod/image/upload/"
        }
      },
      Caps: {
        Front: {
          Filename:
            "https://res.cloudinary.com/publish-prod/image/upload/v1549414039/configurator/caps-front-white.png",
          CD_PublicId: "configurator/caps-front-white",
          CD_Version: "v1549414039",
          CD_Format: "png",
          CD_BasePath: "https://res.cloudinary.com/publish-prod/image/upload/"
        },
        Back: {
          Filename:
            "https://res.cloudinary.com/publish-prod/image/upload/v1549414038/configurator/caps-back-white.png",
          CD_PublicId: "configurator/caps-back-white",
          CD_Version: "v1549414038",
          CD_Format: "png",
          CD_BasePath: "https://res.cloudinary.com/publish-prod/image/upload/"
        }
      },
      Icons: {
        Filename:
          "https://res.cloudinary.com/publish-prod/image/upload/v1549414039/configurator/icon-white.png",
        CD_PublicId: "configurator/icon-white",
        CD_Version: "v1549414039",
        CD_Format: "png",
        CD_BasePath: "https://res.cloudinary.com/publish-prod/image/upload/"
      },
      Spine: {
        Filename:
          "https://res.cloudinary.com/publish-prod/image/upload/v1549414039/configurator/spine-white.png",
        CD_PublicId: "configurator/spine-white",
        CD_Version: "v1549414039",
        CD_Format: "png",
        CD_BasePath: "https://res.cloudinary.com/publish-prod/image/upload/",
        MainColor: "#ffffff"
      },
      Loop: {
        Filename:
          "https://res.cloudinary.com/publish-prod/image/upload/v1549414038/configurator/loop-white.png",
        CD_PublicId: "configurator/loop-white",
        CD_Version: "v1549414038",
        CD_Format: "png",
        CD_BasePath: "https://res.cloudinary.com/publish-prod/image/upload/"
      }
    },
    productLogo: {
      Filename:
        "https://res.cloudinary.com/publish-prod/image/upload/v1549414039/configurator/logo.png",
      CD_PublicId: "configurator/logo",
      CD_Version: "v1549414039",
      CD_Format: "png",
      CD_BasePath: "https://res.cloudinary.com/publish-prod/image/upload/"
    },
    powerUp: {
      Filename:
        "https:///res.cloudinary.com/publish-prod/image/upload/v1549563076/configurator/power-up.png",
      CD_PublicId: "configurator/power-up",
      CD_Version: "v1549563076",
      CD_Format: "png",
      CD_BasePath: "https:///res.cloudinary.com/publish-prod/image/upload/"
    },
    feelingLuckyRandomized: [],
    feelingLuckyIntro: {
      Fabric: null,
      Icon: null,
      Caps: "FL",
      Spine: null,
      Loop: null,
      Text: "Hit me"
    },
    feelingLucky: [
      // TODO: eventually this should get pulled in from an API
      {
        Id: 1,
        Fabric: 48, // Aurora Bora
        Icon: 18, // Cloud
        Caps: 36, // Denim
        Spine: 41, // Denim
        Loop: 42, // Ultraviolet
        Text: "Hit me"
      },
      {
        Id: 2,
        Fabric: 47, // Flower Tower
        Icon: 18, // Cloud
        Caps: 32, // Ultraviolet Purple
        Spine: 37, // Ultraviolet Purple
        Loop: 44, // Seashell Peach
        Text: "Cowabunga"
      },
      {
        Id: 3,
        Fabric: 17, // Forest Green
        Icon: 19, // Denim
        Caps: 36, // Denim
        Spine: 41, // Denim
        Loop: 46, // Denim
        Text: "You are a bit picky, aren't you?"
      },
      {
        Id: 4,
        Fabric: 27, // NY Kitty
        Icon: 9, // Sunset
        Caps: 6, // Sunset
        Spine: 12, // Sunset Red
        Loop: 13, // Sunset Red
        Text: "Miawww!"
      },
      {
        Id: 5,
        Fabric: 28, // Blue Dreams
        Icon: 18, // Cloud
        Caps: 36, // Denim
        Spine: 41, // Denim
        Loop: 50, // Cloud
        Text: "Hit me baby one more time"
      },
      {
        Id: 6,
        Fabric: 26, // Berry Fun
        Icon: 9, // Sunset
        Caps: 6, // Sunset
        Spine: 40, // Cloud
        Loop: 13, // Sunset
        Text: "Next one breaks the internet"
      },
      {
        Id: 7,
        Fabric: 31, // Jungle Bell
        Icon: 9, // Sunset
        Caps: 4, // Night Black
        Spine: 10, // Night Black
        Loop: 49, // Night
        Text: "Pretty please!"
      },
      {
        Id: 8,
        Fabric: 2, // Lagoon Blue
        Icon: 21, // Seashell Peach
        Caps: 33, // Forest Green
        Spine: 38, // Forest Green
        Loop: 43, // Forest Green
        Text: "Still not in love?"
      },
      {
        Id: 9,
        Fabric: 48, // Aurora Bora
        Icon: 21, // Seashell
        Caps: 34, // Seashell
        Spine: 39, // Seashell
        Loop: 42, // ultraviolet
        Text: "It's a match!"
      },
      {
        Id: 10,
        Fabric: 16, // Ultraviolet Purple
        Icon: 7, // Night Black
        Caps: 35, // Cloud
        Spine: 10, // Night Black
        Loop: 42, // Ultraviolet Purple
        Text: "This one's for you"
      },
      {
        Id: 11,
        Fabric: 16, // Ultraviolet Purple
        Icon: 18, // Cloud
        Caps: 5, // Lagoon Blue
        Spine: 11, // Lagoon Blue
        Loop: 15, // Lagoon Blue
        Text: "Show me what you got"
      },
      {
        Id: 12,
        Fabric: 24, // Seashell Peach
        Icon: 20, // Forest Green
        Caps: 4, // Night Black
        Spine: 10, // Night Black
        Loop: 43, // Forest Green
        Text: "La vie en rose..."
      },
      {
        Id: 13,
        Fabric: 25, // Frozen Kingdom
        Icon: 18, // Cloud
        Caps: 33, // Forest
        Spine: 39, // Seashell
        Loop: 44, // Seashell
        Text: "Hit me more"
      },
      {
        Id: 14,
        Fabric: 28, // Blue Dreams
        Icon: 20, // Forest Green
        Caps: 35, // Cloud
        Spine: 41, // Denim
        Loop: 43, // Forest Green
        Text: "You, grumpy cat..."
      },
      {
        Id: 15,
        Fabric: 31, // Jungle Bell
        Icon: 18, // Cloud
        Caps: 33, // Forest
        Spine: 38, // Forest
        Loop: 43, // Forest
        Text: "U mad bro?"
      },
      {
        Id: 16,
        Fabric: 3, // Sunset
        Icon: 19, // Denim
        Caps: 5, // Lagoon Blue
        Spine: 41, // Denim
        Loop: 46, // Denim
        Text: "More cowbell"
      },
      {
        Id: 17,
        Fabric: 1, // Night Black
        Icon: 18, // Cloud
        Caps: 35, // Cloud
        Spine: 10, // Night Black
        Loop: 49, // Night Black
        Text: "Show me more"
      },
      {
        Id: 18,
        Fabric: 47, // Flower Tower
        Icon: 7, // Night
        Caps: 6, // Sunset
        Spine: 12, // Sunset
        Loop: 13, // Sunset
        Text: "OK, next!"
      },
      {
        Id: 19,
        Fabric: 30, // Marble Marvel
        Icon: 22, // Ultraviolet Purple
        Caps: 35, // Cloud
        Spine: 40, // Cloud
        Loop: 49, // Night Black
        Text: "We have more"
      },
      {
        Id: 20,
        Fabric: 24, // Seashell Peach
        Icon: 9, // Sunset Red
        Caps: 32, // Ultraviolet Purple
        Spine: 12, // Sunset
        Loop: 44, // Seashell Peach
        Text: "Oh, we thought it was the one"
      },
      {
        Id: 21,
        Fabric: 1, // Night Black
        Icon: 9, // Sunset Red
        Caps: 4, // Night Black
        Spine: 12, // Sunset
        Loop: 13, // Sunset
        Text: "Yes? No?"
      },
      {
        Id: 22,
        Fabric: 25, // Frozen Kingdom
        Icon: 9, // Sunset Red
        Caps: 35, // Cloud
        Spine: 40, // Cloud
        Loop: 13, // Sunset
        Text: "Too cold for me"
      },
      {
        Id: 23,
        Fabric: 27, // NY Kitty
        Icon: 9, // Sunset
        Caps: 36, // Denim
        Spine: 41, // Denim
        Loop: 46, // Denim
        Text: "Not feeling wild?"
      },
      {
        Id: 24,
        Fabric: 16, // Ultraviolet Purple
        Icon: 21, // Seashell Peach
        Caps: 34, // Seashell Peach
        Spine: 37, // Ultraviolet Purple
        Loop: 42, // Ultraviolet Purple
        Text: "That was our last :("
      }
    ]
  },
  mutations: {
    setLocale(state, value) {
      state.locale = value;
    },
    setCurrency(state, value) {
      state.currency = value;
    },
    setPrice(state, value) {
      state.speakerPrice = value;
    },
    setAccessoryPrice(state, value) {
      state.accessoryPrice = value;
    },
    updateCustomText(state, value) {
      state.configuration.CustomText = value;
    },
    updateInputText(state, value) {
      state.inputText = value;
    },
    setFontToUse(state, value) {
      state.font = value;
    },
    selectSKU(state, value) {
      state.selectedSKU = value;
    },
    addProductOptions(state, rawProductOptions) {
      const productOptions = {};

      // loop over all raw product options to create our new product options object
      rawProductOptions.forEach(optionType => {
        let productOptionObj;
        // if this key doesn't already exist, make it an empty object
        if (!productOptions.hasOwnProperty(optionType.Name)) {
          productOptions[optionType.Name] = {};
        }
        productOptionObj = productOptions[optionType.Name];

        productOptionObj.Id = optionType.Id;
        productOptionObj.SortOrder = optionType.SortOrder;
        productOptionObj.Options = [];
        // now we need to reorganize the product options
        optionType.Options.forEach(
          ({
            AdditionalCost,
            CategoryId,
            ConfigCode,
            Id,
            Images,
            Name,
            MainColor,
            PartNumber,
            Products,
            SortOrder,
            Status
          }) => {
            const optionTypeOptions = {
              ...AdditionalCost,
              CategoryId,
              ConfigCode,
              Id,
              Name,
              MainColor,
              PartNumber,
              Products,
              SortOrder,
              Status
            };
            optionTypeOptions.CategoryName = optionType.Name;
            optionTypeOptions.Images = {};
            // TODO: eventually use the CD_ prefixed items to build out the url
            // builds out Images object
            Images.forEach(
              ({
                FileString,
                CD_PublicId,
                CD_Version,
                CD_Format,
                CD_BasePath,
                Id,
                Type
              }) => {
                /*
              0 = front
              1 = back
              2 = thumbnail
            */
                let img;
                switch (Type) {
                  case 0:
                    img = optionTypeOptions.Images.Front = {};
                    break;
                  case 1:
                    img = optionTypeOptions.Images.Back = {};
                    break;
                  case 2:
                    img = optionTypeOptions.Images.Thumbnail = {};
                    break;
                }
                // TODO: once backend changes rename this to be the same
                if (img) {
                  img.Filename = FileString;
                  img.CD_PublicId = CD_PublicId;
                  img.CD_BasePath = CD_BasePath;
                  img.CD_Format = CD_Format;
                  img.CD_Version = CD_Version;
                  img.Id = Id;
                }
              }
            );
            productOptionObj.Options.push(optionTypeOptions);
          }
        );
      });

      state.productOptions = productOptions;
    },
    selectOption(state, option) {
      state.configuration[option.CategoryName] = option.Id;
    },
    clearConfigurationOptions(state) {
      const configurationParts = Object.keys(state.configuration);
      configurationParts.forEach(option => {
        state.configuration[option] = null;
      });
      state.configuration.CustomText = null;
      state.inputText = null;
    },
    setProduct(state, value) {
      // set the full product to the store
      state.productBeingConfigured = value;
      console.log(state.locale, "locale");
      // get the product SKU that matches our locale
      const productDetails = state.productBeingConfigured.SKUs.find(function(
        product
      ) {
        return product.Locale.Name.toLowerCase() === state.locale;
      });
      console.log(state.productBeingConfigured, "product being configured");
      console.log(productDetails);
      state.productSKU = productDetails.Number;
      // set default selected SKU for the final page
      state.selectedSKU = productDetails.Number;
      state.storeId = productDetails.StoreId;
    },
    setPowerUpProduct(state, value) {
      state.powerUp = value;
      const accessoryDetails = state.powerUp.SKUs.find(function(product) {
        return product.Locale.Name.toLowerCase() === state.locale;
      });
      state.accessorySKU = accessoryDetails.Number;
    },
    storeLoaded(state, value) {
      state.loaded = value;
    },
    setSessionToken(state, value) {
      state.sessionToken = value;
    },
    updateLuckyCountTo(state, value) {
      state.luckyCount = value;
    },
    editingFeelingLucky(state, value) {
      state.editingFeelingLucky = value;
    },
    httpErrorOccurred(state, value) {
      console.log("error occurred");
      state.httpError = value;
    },
    setSocialImageURL(state, value) {
      state.socialImageURL = value;
    },
    setFeelingLuckyOrder(state, value) {
      state.feelingLuckyRandomized = value;
    }
  },
  actions: {
    getProducts() {
      return (
        fetch("/api/config/getproducts")
          // return fetch('/getproducts.json')
          .then(res => handleErrors(res))
          .then(res => res.json())
          .then(json => {
            // set the product being configured
            // TODO: later if there's more products we need to change this
            this.commit("setProduct", json[0]);
            this.commit("setPowerUpProduct", json[1]);
          })
      );
    },
    getProductOptions(store, { productId }) {
      fetch(`/api/config/getoptions/${productId}`)
        .then(res => handleErrors(res))
        // fetch('/boom-options.json')
        .then(res => res.json())
        .then(json => {
          this.commit("addProductOptions", json);
        });
    },
    getProductPricing(context) {
      // speaker
      fetch(
        `/api/config/GetPrice?region=${context.state.locale}&sku=${context.state.productSKU}`
      )
        .then(res => handleErrors(res))
        .then(res => res.json())
        .then(json => {
          console.log(json);
          context.commit("setCurrency", json.salePriceWithQuantity.currency);
          context.commit("setPrice", json.salePriceWithQuantity.value);
          context.commit("storeLoaded", true);
        });
      // accessory
      fetch(
        `/api/config/GetPrice?region=${context.state.locale}&sku=${context.state.accessorySKU}`
      )
        .then(res => handleErrors(res))
        .then(res => res.json())
        .then(json => {
          console.log(json);
          context.commit("setAccessoryPrice", json.salePriceWithQuantity.value);
        });
    }
  }
});

function handleErrors(res) {
  if (!res.ok) {
    store.commit("httpErrorOccurred", true);
    throw Error(res.statusText);
  } else {
    return res;
  }
}

export default store;
